export default __webpack_public_path__ + "static/media/my_Information.d055c68d.pdf";